import { NextHead } from '../../head';

import { ClosedPageLayout } from './ClosedPageLayout';

export function SiteUnpublishedPage() {
  return (
    <>
      <NextHead />
      <ClosedPageLayout title="채용 사이트 운영이 종료되었어요." />
    </>
  );
}
